import type { IBaseInvoice, IInvoiceViewRow } from 'src/types/invoices';

export const parseBaseInvoiceFromFlatInvoiceRow = (x: IInvoiceViewRow): IBaseInvoice => {
  return {
    id: x.id,
    invoiceNo: x.invoiceNo,

    dueDate: x.dueDate,
    invoiceDate: x.invoiceDate,
    countryCode: x.countryCode,
    paymentReference: x.paymentReference,

    status: x.status,
    stage: x.stage,
    paymentStatus: x.paymentStatus,

    currency: x.currency ?? '',

    customerNo: x.customerNo,
    customerId: x.customerId,

    // Hydrate nested objects expected by FE
    customer: {
      id: x.customerId,
      customerNo: x.customerNo,
      customerName: x.customerName ?? '',
    },

    client: {
      id: x.clientId,
      name: x.clientName ?? '',
      logo_uri: x.clientLogo ?? '',
    },

    metadata: x.metadata,

    pdfURL: x.pdfURL,

    // Numbers (BE sends strings)
    totalRemainingBalance:
      x.totalRemainingBalance !== null ? parseFloat(x.totalRemainingBalance) : 0,
    totalAmount: x.totalAmount !== null ? parseFloat(x.totalAmount) : 0,

    remainingAmount:
      x.totalRemainingBalance !== null
        ? Number(x.totalRemainingBalance)
        : x.totalRemainingBalance !== null
          ? parseFloat(x.totalRemainingBalance)
          : 0,

    debitInvoiceReferences: x.debitInvoiceReferences ?? [],

    score: x.rank_score ? parseFloat(String(x.rank_score)) : 0,

    totalCacheAmount: x.totalAmount ? parseFloat(x.totalAmount) : undefined,
    lastPaymentTransactionType: x.lastPaymentTransactionType,

    // New fields
    serviceLineName: x.serviceLineName,
    fee: x.fee,
    originalTotalAmount: x.originalTotalAmount,
    paymentMethod: x.paymentMethod,
    paymentDate: x.paymentDate,
    lastEscalationDate: x.lastEscalationDate,
    whenEscalatingToDebtCollection: x.whenEscalatingToDebtCollection,
    paidAmount: x.paidAmount,
    daysOverdue: x.daysOverdue,
    orgNo: x.orgNo,
    distributionChannel: x.distributionChannel,
    reminderDate: x.reminderDate,
    vatAmount: x.vatAmount,
    pausedType: x.pausedType,
    pausedLevel: x.pausedLevel,
    pausedDuration: x.pausedDuration,
  };
};
